<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <archivo-adjunto-caso-sidebar
      v-if="addNewDataSidebar"
      :propModeView="sidebarViewMode"
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      @refresh="updateTable"
      :data="sidebarData"
      :licitacionProp="licitacionProp"
    />

    <vs-table
      ref="table"
      pagination
      :max-items="itemsPerPage"
      search
      :data="archivos_adjuntos_caso"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ADD NEW -->
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
            <span class="ml-2 text-base text-primary">Adjuntar archivo</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                archivos_adjuntos_caso.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : archivos_adjuntos_caso.length
              }}
              de {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th :key="indexth" v-for="(row, indexth) in meta" v-if="row">
          <p class="product-name font-medium truncate">{{ row }}</p>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            v-if="tr"
          >
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.id }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.nameAttachments }}</p>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <!-- <feather-icon
                icon="EyeIcon"
                svgClasses="w-5 h-5 hover:text-dark stroke-current"
              />    -->
              <feather-icon
                icon="DownloadIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                class="ml-2"
                @click.stop="downloadFile(tr)"
              />      
              <!-- <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                      class="ml-2" @click.stop="editData(tr)"/>
                        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                      class="ml-2" @click.stop="deleteData(tr.IDETAPA)"/> -->
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import ArchivoAdjuntoCasoSidebar from '@/views/archivo-adjunto-caso/ArchivoAdjuntoCasoSidebar.vue'
import ArchivoAdjuntoCasoModule from '@/store/archivo-adjunto-caso-module/moduleDataList.js'
//import LocationArchivoAdjuntoLicitacionListView from '@/views/location-archivo-adjunto-licitacion/LocationArchivoAdjuntoLicitacionListView.vue'

export default {
  props: {
    licitacionProp: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ArchivoAdjuntoCasoSidebar
    // LocationArchivoAdjuntoLicitacionListView
  },
  created () {
    if (!ArchivoAdjuntoCasoModule.isRegistered) {
      this.$store.registerModule('ArchivoAdjuntoCasoModule', ArchivoAdjuntoCasoModule)
      ArchivoAdjuntoCasoModule.isRegistered = true
    }
    //this.updateTable()
  },
  mounted () {
    this.isMounted = true
  },
  updated () {
    //console.log('archivos_adjuntos_caso', this.archivos_adjuntos_caso)
  },
  data () {
    return {
      selected: [],
      itemsPerPage: 4,
      isMounted: false,
      indexDelete: -1,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      sidebarViewMode: true
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    archivos_adjuntos_caso () {
      return this.$store.state.ArchivoAdjuntoCasoModule.archivos_adjuntos_caso
    },
    meta () {
      return this.$store.state.ArchivoAdjuntoCasoModule.meta
    },
    queriedItems () {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.archivos_adjuntos_caso.length
    }
  },
  methods: {
    addNewData () {
      this.sidebarData = {}
      this.sidebarViewMode = false
      this.toggleDataSidebar(true)
    },
    deleteData (etapa_licitacionId) {
      this.indexDelete = this.archivos_adjuntos_caso.findIndex(
        (p) => p.IDETAPA === etapa_licitacionId
      )
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar eliminar',
        text: `¿Desea eliminar la etapa "${
          this.archivos_adjuntos_caso[this.indexDelete].NOMBRE
        }"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar',
        cancelText: 'Cancelar'
      })
    },
    deleteRecord () {
      const idArchivoAdjuntoLicitacionTmp = this.archivos_adjuntos_caso[this.indexDelete].IDETAPA
      const nameArchivoAdjuntoLicitacionTmp = this.archivos_adjuntos_caso[this.indexDelete].NOMBRE
      this.$store
        .dispatch('ArchivoAdjuntoCasoModule/removeArchivoAdjuntoCaso', idArchivoAdjuntoLicitacionTmp)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: 'ArchivoAdjunto eliminada',
            text: `La etapa ${nameArchivoAdjuntoLicitacionTmp} ha sido eliminada del sistema.`
          })
          this.updateTable()
        })
        .catch((ex) => {
          this.$vs.dialog({
            color: 'danger',
            title: 'Error al actualizar datos',
            text: 'No es posible actualizar en la base de datos',
            acceptText: 'Aceptar',
            accept: console.log('Ex:', ex)
          })
        })
    },
    displayData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.sidebarViewMode = true
      this.toggleDataSidebar(true)
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.sidebarViewMode = false
      this.toggleDataSidebar(true)
    },
    displayView () {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    downloadFile (data) {
      console.log('data', data)
      window.open(
        data.cloudUbication || 'https://www.google.com',
        '_blank' // <- This is what makes it open in a new window.
      )
    },
    getOrderStatusColor (status) {
      if (status === 'on_hold') return 'warning'
      if (status === 'delivered') return 'success'
      if (status === 'canceled') return 'danger'
      return 'primary'
    },
    getPopularityColor (num) {
      if (num > 90) return 'success'
      if (num > 70) return 'primary'
      if (num >= 50) return 'warning'
      if (num < 50) return 'danger'
      return 'primary'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    updateTable () {
      this.$vs.loading()
      if (this.licitacionProp !== undefined) {
        this.$store
          .dispatch('ArchivoAdjuntoCasoModule/getArchivoAdjuntosCasoByCaso', this.licitacionProp)
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()

            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text:
                'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
              acceptText: 'Aceptar'
            })
          })
      } else {
        this.$store
          .dispatch('ArchivoAdjuntoCasoModule/getAllArchivoAdjuntosCaso')
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(() => {
            this.$vs.loading.close()

            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text:
                'No se pudo realizar la conexión, inténtelo de nuevo más tarde.',
              acceptText: 'Aceptar'
            })
          })
      }
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
              Below media-queries is fix for responsiveness of action buttons
              Note: If you change action buttons or layout of this page, Please remove below style
            */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
